import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import Header from './layout/Header';
import Footer from './layout/Footer';
import '../style/index.css';

class App extends Component {
	static updatePage(path) {
		if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
		window.dataLayer.push({
			event: 'PageView',
			values: {
				path,
			},
		});
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
			App.updatePage(this.props.location.pathname);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname && typeof window !== 'undefined') {
			App.updatePage(this.props.location.pathname);
		}
	}

	render() {
		const { route } = this.props;

		return (
			<div id="app">
				<Header />
				{ renderRoutes(route.routes) }
				<Footer />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./containers/App.jsx